<script setup lang="ts">
import type { CustomFieldProps } from '../types';
import CustomFieldInputBase from '../CustomFieldInputBase.vue';
import { useCustomFieldProps } from '@satellite/composables/useCustomFieldProps';

/**
 * Boolean field type - toggle switch
 */
const props = defineProps<CustomFieldProps>();

const emit = defineEmits<{
  'update:model-value': [value: boolean];
  /** @deprecated Use update:model-value instead */
  // TODO: Remove this event after the migration is complete
  input: [value: boolean];
}>();

const { normalizedProps } = useCustomFieldProps(props);

function handleInput(value: boolean) {
  emit('update:model-value', value);
  emit('input', value);
}
</script>

<template>
  <custom-field-input-base :field="field" v-bind="normalizedProps">
    <v-switch
      :model-value="modelValue"
      :readonly="normalizedProps.readOnly"
      :hide-details="normalizedProps.hideDetails"
      color="primary"
      @update:model-value="handleInput" />
  </custom-field-input-base>
</template>
